import { render, staticRenderFns } from "./StudentModuleProgress.vue?vue&type=template&id=44d77c52&"
import script from "./StudentModuleProgress.vue?vue&type=script&lang=js&"
export * from "./StudentModuleProgress.vue?vue&type=script&lang=js&"
import style0 from "./StudentModuleProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports